module.exports = __webpack_public_path__ + "img/teachersbyalternatives.811a85d5.svg";